module.exports = __webpack_public_path__ + "c7a62d7a11f9084f13919452f6852348.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/outbreaks.png
 ** module id = 1070
 ** module chunks = 0
 **/